class ImportApi {
  async saveCustomers(accessToken, object, importName, progress, index) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/save`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ objects: [object], import_name: importName, progress, index }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async updateCustomers(accessToken, civility, firstname, lastname, phone, phoneFix, email, adress, zip, city, department, region, profession, adeliRpps, commentaire, importName) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/update`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ civility, firstname, lastname, phone, phone_fix: phoneFix, email, adress, zip, city, department, region, profession, adeli_rpps: adeliRpps, antecedents: commentaire, import_name: importName }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async addCustomers(accessToken, civility, firstname, lastname, phone, phoneFix, email, adress, zip, city, department, region, profession, adeliRpps, commentaire, importName) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/add`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ civility, firstname, lastname, phone, phone_fix: phoneFix, email, adress, zip, city, department, region, profession, adeli_rpps: adeliRpps, antecedents: commentaire, import_name: importName }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async removeCustomers(accessToken, importName) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/delete`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ import_name: importName }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async downloadImport(accessToken, importId) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/download-import`;

    try {
      const resp = await fetch(urlImport, {
        method: 'POST',
        body: JSON.stringify({ import_id: importId }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });

      if (!resp.ok) {
        throw new Error(`HTTP error! status: ${resp.status}`);
      }

      const json = await resp.json();

      if (json.status === 200 && json.data && json.data.csv_content && json.data.filename) {
        return Promise.resolve(json.data);
      } else if (json.status === 404) {
        return Promise.resolve({
          csv_content: '',
          filename: `import_${importId}.csv`
        });
      } else {
        throw new Error(json.message || 'Erreur lors du téléchargement');
      }
    } catch (error) {
      console.error('Error in downloadImport:', error);
      throw error;
    }
  }

  async getImports(accessToken) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/get`;

    const resp = await fetch(urlImport, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async deleteImport(accessToken, importId) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/delete-import`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ import_id: importId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    }); 

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async getCustomersWithSessionsByImport(accessToken, importId) {
    const url = `${process.env.REACT_APP_API_URL}/api/import/customers-with-sessions`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ import_id: importId }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json.data);
  }

  async deleteCustomersByImport(accessToken, importId, mode) {
    const url = `${process.env.REACT_APP_API_URL}/api/import/delete-customers-by-import`;
    const resp = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ import_id: importId, mode }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });
    const json = await resp.json();
    return Promise.resolve(json);
  }

  async checkDuplicates(accessToken, data, mapping) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/check-duplicates`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify({ 
        data,
        mapping,
        threshold: 0.92 // Seuil de similarité pour Levenshtein (80%)
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();

    return Promise.resolve(json.data);
  }

  async importContacts(accessToken, data) {
    const urlImport = `${process.env.REACT_APP_API_URL}/api/import/import-contacts`;

    const resp = await fetch(urlImport, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    });

    const json = await resp.json();
    if (!resp.ok || json.status !== 200) {
      const message = (json && json.message) ? json.message : 'Erreur lors de l\'import des contacts';
      throw new Error(message);
    }
    return Promise.resolve(json);
  }
}
export const importApi = new ImportApi();
